<template>
  <div class="EditResume">
    <div class="block" style="padding: 0 16px">
      <el-form label-position="left">
        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 16px">
          <div
            style="
              display: flex;
              flex-direction: column;
              justify-content: space-between;
            "
          >
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: flex-start;
                white-space: nowrap;
                padding: 8px 0;
                height: 36px;
              "
            >
              <p><span style="color: #f56c6c">* </span>国籍</p>
              <input
                class="text-right text-input"
                style="width: 100%"
                v-model="baseInfo.nationality"
                placeholder="请填写国籍"
              />
            </div>
            <div
              class="b-t"
              style="
                display: flex;
                align-items: center;
                white-space: nowrap;
                height: 36px;
                padding: 8px 0;
              "
            >
              <span><span style="color: #f56c6c">* </span>在职状态</span>
              <select
                class="text-select items-normal-select"
                style="text-align: right"
                v-model="baseInfo.resumeStatus"
              >
                <option
                  v-for="item in resumeStatusList"
                  :value="item.value"
                  :selected="baseInfo.resumeStatus == item.value"
                >
                  {{ item.label }}
                </option>
              </select>
            </div>
          </div>
          <div
            style="
              display: flex;
              align-items: flex-start;
              justify-content: space-between;
              padding: 16px 0;
            "
          >
            <p>
              <span style="display: block; padding: 16px 0">头像</span>
              <span style="display: block; font-size: 12px">(本人照片)</span>
            </p>
            <el-upload
              style="flex: 1; text-align: center; line-height: 70px"
              action="#"
              :show-file-list="false"
              :http-request="uploadFile"
            >
              <img
                v-if="baseInfo.avatar"
                :src="baseInfo.avatar"
                class="rounded-full"
                width="70px"
                height="70px"
              />
              <i v-else class="el-icon-plus"></i>
            </el-upload>
          </div>
        </div>

        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 16px">
          <div
            class="b-t"
            style="display: flex; align-items: center; white-space: nowrap"
          >
            <span><span style="color: #f56c6c">* </span>姓名</span>
            <input
              class="text-right text-input"
              v-model="baseInfo.name"
              style="width: 100%"
              placeholder="请填写姓名"
            />
          </div>
          <div
            style="
              display: flex;
              align-items: center;
              justify-content: space-between;
              white-space: nowrap;
              padding: 8px 0;
              height: 36px;
            "
            class="b-t"
          >
            <p style="margin-right: 20px">
              <span style="color: #f56c6c">* </span>性别
            </p>
            <select v-model="baseInfo.gender" class="text-input text-select">
              <option value="0" selected>男</option>
              <option value="1">女</option>
            </select>
          </div>
        </div>

        <el-form-item required label="出生日期" class="b-t">
          <el-date-picker
            v-model="baseInfo.birthDate"
            type="date"
            placeholder="请选择"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            :default-value="new Date('1998-01-01')"
            style="width: 100%"
          />
<!--          <input-->
<!--            type="date"-->
<!--            v-model="baseInfo.birthDate"-->
<!--            class="text-input"-->
<!--            placeholder="请选择出生日期"-->
<!--          />-->
        </el-form-item>

        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 16px">
          <div
            style="
              display: flex;
              align-items: center;
              justify-content: space-between;
              white-space: nowrap;
              padding: 8px 0;
              height: 36px;
            "
            class="b-t"
          >
            <p style="margin-right: 20px">
              <span style="color: #f56c6c">* </span>学历
            </p>
            <select
              v-model="baseInfo.firstEducation"
              class="text-input text-select"
              style="width: 100%"
            >
              <option
                v-for="item in educationList"
                :key="item.value"
                :value="item.value"
                :selected="baseInfo.firstEducation == item.value"
              >
                {{ item.label }}
              </option>
            </select>
          </div>

          <div
            style="
              display: flex;
              align-items: center;
              justify-content: space-between;
              white-space: nowrap;
              padding: 8px 0;
              height: 36px;
            "
            class="b-t"
          >
            <p style="margin-right: 20px">
              <span style="color: #f56c6c">* </span>婚姻状况
            </p>
            <select
              v-model="baseInfo.maritalStatus"
              class="text-input text-select"
            >
              <option :value="1">未婚</option>
              <option :value="2">已婚</option>
              <option :value="3">离异</option>
            </select>
          </div>
        </div>

        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 16px">
          <div
            style="
              display: flex;
              align-items: center;
              justify-content: flex-start;
              white-space: nowrap;
              border-top: 1px solid #cccccc;
              padding: 8px 0;
              height: 40px;
            "
          >
            <p>民族</p>
            <input
              class="text-right text-input"
              style="width: 100%"
              v-model="baseInfo.nation"
              placeholder="请填写民族"
            />
          </div>
          <div
            class="b-t"
            style="display: flex; align-items: center; white-space: nowrap"
          >
            <span>宗教</span>
            <input
              class="text-right text-input"
              v-model="baseInfo.religion"
              style="width: 100%"
              placeholder="请填写宗教"
            />
          </div>
        </div>

        <!-- <el-form-item label="健康状态" class="b-t">
          <input
            class="text-right text-input"
            v-model="baseInfo.healthStatus"
            style="width: 100%"
            placeholder="健康或残疾"
          />
        </el-form-item> -->

        <el-form-item required label="户籍" class="b-t">
          <input
            class="text-right text-input"
            v-model="baseInfo.registeredResidence"
            placeholder="请填写户籍所在地"
          />
        </el-form-item>

        <el-form-item required label="现居住地" class="b-t">
          <input
            class="text-right text-input"
            v-model="baseInfo.address"
            placeholder="请填写现居住地"
          />
        </el-form-item>
      </el-form>
    </div>

    <!-- <div class="block" style="padding: 0 16px">
      <el-form label-position="left">
        <el-form-item label="目前公司">
          <input
            class="text-right text-input"
            v-model="baseInfo.currentCompany"
            placeholder="请填写目前公司名称"
          />
        </el-form-item>
        <el-form-item label="目前职位" class="b-t">
          <input
            class="text-right text-input"
            v-model="baseInfo.targetJob"
            placeholder="请填写目前职位名称"
          />
        </el-form-item>

      </el-form>
    </div> -->

    <div class="block" style="padding: 0 16px">
      <el-form label-position="left">
        <el-form-item required label="手机号">
          <input
            class="text-right text-input"
            v-model="baseInfo.phone"
            placeholder="请输入手机号"
          />
        </el-form-item>
        <el-form-item required label="邮箱" class="b-t">
          <input
            class="text-right text-input"
            v-model="baseInfo.email"
            placeholder="请填写邮箱"
          />
        </el-form-item>
        <el-form-item label="微信号" class="b-t">
          <input
            class="text-right text-input"
            v-model="baseInfo.wechat"
            placeholder="请填写微信号"
          />
        </el-form-item>
        <el-form-item label="QQ" class="b-t">
          <input
            class="text-right text-input"
            v-model="baseInfo.qq"
            placeholder="请填写QQ号"
          />
        </el-form-item>
      </el-form>
    </div>

    <div class="block" style="padding: 0 16px">
      <el-form label-position="left">
        <el-form-item required label="意向职位">
          <input
            class="text-right text-input"
            v-model="baseInfo.jobFunction"
            placeholder="请填写意向职位"
          />
        </el-form-item>
        <el-form-item required label="期望年薪" class="b-t">
          <input
            type="number"
            style="background-color: #f8f8f8; width: 80px"
            class="text-right text-input"
            v-model="baseInfo.expectedSalary"
          />
          <span style="margin-left: 10px">万元</span>
        </el-form-item>
        <el-form-item required label="意向行业" class="b-t">
          <select
            v-model="baseInfo.itemId"
            class="text-select text-right"
            placeholder="请选择意向行业"
          >
            <option
              v-for="item in industryList"
              :key="item.typeId"
              :value="item.item.itemId"
            >
              {{ item.item.itemName }}
            </option>
          </select>
        </el-form-item>
        <el-form-item label="意向城市" class="b-t">
          <input
            class="text-right text-input"
            v-model="baseInfo.targetCity"
            placeholder="请填写意向城市"
          />
        </el-form-item>
      </el-form>
    </div>

    <!-- 新增工作经验 -->
    <div
      v-for="(workExperiences, index) in showForm.workExperiences"
      :key="index"
    >
      <div class="block" style="padding: 0 16px; margin-top: 16px">
        <el-form label-position="left">
          <el-form-item required label="公司名称">
            <input
              style="width: 100%"
              class="text-right text-input"
              v-model="workExperiences.companyName"
              placeholder="请输入公司名称"
            />
          </el-form-item>
          <el-form-item required label="所在部门" class="b-t">
            <input
              class="text-right text-input"
              v-model="workExperiences.department"
              placeholder="请填写所在部门"
            />
          </el-form-item>
          <el-form-item required label="职位" class="b-t">
            <input
              class="text-right text-input"
              v-model="workExperiences.position"
              placeholder="请填写职位"
            />
          </el-form-item>
          <el-form-item required label="属下人数" class="b-t">
            <input
              class="text-right text-input"
              type="number"
              v-model="workExperiences.subordinates"
              placeholder="请填写属下人数"
            />
          </el-form-item>
          <el-form-item required label="在职状态" class="b-t">
            <select
              class="text-select"
              v-model="workExperiences.employmentStatus"
            >
              <option value="0">在职</option>
              <option value="1">离职</option>
            </select>
          </el-form-item>
          <el-form-item required label="开始时间" class="b-t">
            <el-date-picker
              v-model="workExperiences.startDate"
              :max="workExperiences.endDate"
              type="month"
              placeholder="开始时间"
              value-format="yyyy-MM-dd"
              format="yyyy-MM"
              style="width: 100%"/>
<!--            <input-->
<!--              class="text-right text-input"-->
<!--              type="date"-->
<!--              v-model="workExperiences.startDate"-->
<!--              :max="workExperiences.endDate"-->
<!--              placeholder="开始时间"-->
<!--            />-->
          </el-form-item>
          <el-form-item required label="结束时间" class="b-t">
            <el-date-picker
              v-model="workExperiences.endDate"
              :min="workExperiences.startDate"
              type="month"
              placeholder="结束时间"
              value-format="yyyy-MM-dd"
              format="yyyy-MM"
              style="width: 100%"/>
<!--            <input-->
<!--              class="text-right text-input"-->
<!--              type="date"-->
<!--              v-model="workExperiences.endDate"-->
<!--              :min="workExperiences.startDate"-->
<!--              placeholder="结束时间"-->
<!--            />-->
          </el-form-item>
          <el-form-item required label="工作内容" class="b-t">
            <input
              class="text-right text-input"
              v-model="workExperiences.selfEvaluation"
              placeholder="请填写工作内容"
            />
          </el-form-item>
          <div
            style="display: grid; gap: 20px; grid-template-columns: 1fr 1fr 1fr"
          >
            <el-button
              class="save-button"
              style="margin-top: 0; margin-bottom: 16px"
              @click="showForm.workExperiences.splice(index, 1)"
              >删除</el-button
            >
            <el-button
              class="save-button"
              style="margin-top: 0; margin-bottom: 16px"
              @click="scrollTo()"
              >修改</el-button
            >
            <el-button
              class="save-button"
              style="margin-top: 0; margin-bottom: 16px"
              @click="
                showForm.workExperiences.push({
                  companyName: '',
                  department: '',
                  position: '',
                  subordinates: '',
                  employmentStatus: '1',
                  startDate: '',
                  endDate: '',
                  selfEvaluation: '',
                })
              "
              >新增</el-button
            >
          </div>
        </el-form>
      </div>
    </div>
    <el-button
      v-if="showForm.workExperiences.length == 0"
      class="save-button"
      type="primary"
      @click="
        showForm.workExperiences.push({
          companyName: '',
          department: '',
          position: '',
          subordinates: '',
          employmentStatus: '1',
          startDate: '',
          endDate: '',
          selfEvaluation: '',
        })
      "
      >新增工作经验</el-button
    >

    <!-- 新增项目经验 -->
    <div
      v-for="(projectExperience, index) in showForm.projectExperience"
      :key="index"
    >
      <div class="block" style="padding: 0 16px; margin-top: 16px">
        <el-form label-position="left">
          <el-form-item required label="项目名称">
            <input
              class="text-right text-input"
              v-model="projectExperience.projectName"
              placeholder="请输入项目名称"
            />
          </el-form-item>
          <el-form-item required label="项目职位" class="b-t">
            <input
              class="text-right text-input"
              v-model="projectExperience.projectPosition"
              placeholder="请填写项目职位"
            />
          </el-form-item>
          <el-form-item required label="开始时间" class="b-t">
            <el-date-picker
              v-model="projectExperience.startDate"
              :max="projectExperience.endDate"
              type="month"
              placeholder="开始时间"
              value-format="yyyy-MM-dd"
              format="yyyy-MM"
              style="width: 100%"/>
          </el-form-item>
          <el-form-item required label="结束时间" class="b-t">
            <el-date-picker
              v-model="projectExperience.endDate"
              :min="projectExperience.startDate"
              type="month"
              placeholder="结束时间"
              value-format="yyyy-MM-dd"
              format="yyyy-MM"
              style="width: 100%"/>
<!--            <input-->
<!--              class="text-right text-input"-->
<!--              type="date"-->
<!--              v-model="projectExperience.endDate"-->
<!--              :min="projectExperience.startDate"-->
<!--              placeholder="结束时间"-->
<!--            />-->
          </el-form-item>
          <el-form-item required label="项目介绍" class="b-t">
            <input
              class="text-right text-input"
              v-model="projectExperience.projectDescription"
              placeholder="请填写项目介绍"
            />
          </el-form-item>
          <div
            style="display: grid; gap: 20px; grid-template-columns: 1fr 1fr 1fr"
          >
            <el-button
              class="save-button"
              style="margin-top: 0; margin-bottom: 16px"
              @click="showForm.projectExperience.splice(index, 1)"
              >删除</el-button
            >
            <el-button
              class="save-button"
              style="margin-top: 0; margin-bottom: 16px"
              @click="scrollTo()"
              >修改</el-button
            >
            <el-button
              class="save-button"
              style="margin-top: 0; margin-bottom: 16px"
              @click="
                showForm.projectExperience.push({
                  projectName: '',
                  projectPosition: '',
                  startDate: '',
                  endDate: '',
                  projectDescription: '',
                })
              "
              >新增</el-button
            >
          </div>
        </el-form>
      </div>
    </div>
    <el-button
      class="save-button"
      v-if="showForm.projectExperience.length == 0"
      type="primary"
      @click="
        showForm.projectExperience.push({
          projectName: '',
          projectPosition: '',
          startDate: '',
          endDate: '',
          projectDescription: '',
        })
      "
      >新增项目经历</el-button
    >

    <!-- 新增教育经验 -->
    <div v-for="(educations, index) in showForm.educations" :key="index">
      <div class="block" style="padding: 0 16px; margin-top: 16px">
        <el-form label-position="left">
          <el-form-item required label="学校名称">
            <input
              class="text-right text-input"
              v-model="educations.schoolName"
              placeholder="请输入学校名称"
            />
          </el-form-item>
          <el-form-item required label="学校类型" class="b-t">
            <select
              class="text-select"
              v-model="educations.schoolType"
              placeholder="请选择学校类型">
              <option
                v-for="item in schoolTypeList"
                :key="item.value"
                :value="item.value"
              >
                {{ item.label }}
              </option>
            </select>
          </el-form-item>
          <el-form-item required label="专业名称" class="b-t">
            <input
              class="text-right text-input"
              v-model="educations.major"
              placeholder="请填写专业名称"
            />
          </el-form-item>
          <el-form-item required label="学历" class="b-t">
            <select class="text-select text-right" v-model="educations.degree">
              <option
                v-for="item in educationList"
                :key="item.value"
                :value="item.value"
              >
                {{ item.label }}
              </option>
            </select>
          </el-form-item>
          <el-form-item required label="在读状态" class="b-t">
            <select
              class="text-select"
              v-model="educations.enrollmentStatus"
              placeholder="请选择在读状态"
            >
              <option :value="0">是</option>
              <option :value="1">不是</option>
            </select>
          </el-form-item>
          <el-form-item required label="开始时间" class="b-t">
            <el-date-picker
              v-model="educations.startDate"
              :max="educations.endDate"
              type="month"
              placeholder="开始时间"
              value-format="yyyy-MM-dd"
              format="yyyy-MM"
              style="width: 100%"/>
<!--            <input-->
<!--              class="text-right text-input"-->
<!--              type="date"-->
<!--              v-model="educations.startDate"-->
<!--              :max="educations.endDate"-->
<!--              placeholder="开始时间"-->
<!--            />-->
          </el-form-item>
          <el-form-item required label="结束时间" class="b-t">
            <el-date-picker
              v-model="educations.endDate"
              :min="educations.startDate"
              type="month"
              placeholder="结束时间"
              value-format="yyyy-MM-dd"
              format="yyyy-MM"
              style="width: 100%"/>
<!--            <input-->
<!--              class="text-right text-input"-->
<!--              type="date"-->
<!--              v-model="educations.endDate"-->
<!--              :min="educations.startDate"-->
<!--              placeholder="结束时间"-->
<!--            />-->
          </el-form-item>
          <el-form-item required label="专业描述" class="b-t">
            <input
              class="text-right text-input"
              v-model="educations.majorDescription"
              placeholder="请填写专业描述"
            />
          </el-form-item>
          <div
            style="display: grid; gap: 20px; grid-template-columns: 1fr 1fr 1fr"
          >
            <el-button
              class="save-button"
              style="margin-top: 0; margin-bottom: 16px"
              @click="showForm.educations.splice(index, 1)"
              >删除</el-button
            >
            <el-button
              class="save-button"
              style="margin-top: 0; margin-bottom: 16px"
              @click="scrollTo()"
              >修改</el-button
            >
            <el-button
              class="save-button"
              style="margin-top: 0; margin-bottom: 16px"
              @click="
                showForm.educations.push({
                  schoolName: '',
                  major: '',
                  degree: '',
                  schoolType: '',
                  enrollmentStatus: 1,
                  startDate: '',
                  endDate: '',
                  majorDescription: '',
                })
              "
              >新增</el-button
            >
          </div>
        </el-form>
      </div>
    </div>
    <el-button
      class="save-button"
      v-if="showForm.educations.length == 0"
      type="primary"
      @click="
        showForm.educations.push({
          schoolName: '',
          major: '',
          degree: '',
          schoolType: '',
          enrollmentStatus: 1,
          startDate: '',
          endDate: '',
          majorDescription: '',
        })
      "
      >新增教育经历</el-button
    >

    <div class="block" style="padding: 0 16px">
      <el-form label-position="left">
        <el-form-item label="语言技能">
          <input
            class="text-right text-input"
            v-model="baseInfo.languageSkill"
            placeholder="请输入语言技能"
          />
        </el-form-item>
        <div class="b-t" style="padding-top: 16px">
          <p>自我评价</p>
          <textarea
            class="text-teatarea"
            v-model="baseInfo.selfEvaluation"
            placeholder="请填写自我评价"
            rows="3"
          >
          </textarea>
        </div>
      </el-form>
    </div>

    <p class="skill-tag">我的技能标签</p>
    <el-tag
      :key="tag"
      v-for="tag in dynamicTags"
      closable
      :disable-transitions="false"
      @close="handleClose(tag)"
    >
      {{ tag }}
    </el-tag>
    <el-input
      class="input-new-tag"
      v-if="inputVisible"
      v-model="inputValue"
      ref="saveTagInput"
      size="small"
      @keyup.enter.native="handleInputConfirm"
      @blur="handleInputConfirm"
    >
    </el-input>
    <el-button
      v-else-if="!inputVisible && dynamicTags.length < 5"
      class="button-new-tag"
      size="small"
      @click="showInput"
      >+ 添加</el-button
    >

    <el-button class="save-button fixed-bottom" type="primary" @click="save()"
      >保存</el-button
    >
  </div>
</template>

<script>
import wx from "weixin-js-sdk";

const url = "https://api.abopin.com/hire/";
// const url = "http://192.168.8.16:7601/";
// const url = "https://hireapi.abopin.com/hire/";

const default_avatar =
  "https://bopin.oss-cn-shenzhen.aliyuncs.com/avatar/boy1x.png";

const mindEducationList = [
  {
    label: "博士后",
    value: "8",
  },
  {
    label: "博士",
    value: "6",
  },
  {
    label: "硕士",
    value: "5",
  },
  {
    label: "本科",
    value: "4",
  },
  {
    label: "大专",
    value: "3",
  },
  {
    label: "高中",
    value: "2",
  },
  {
    label: "中专/中技",
    value: "1",
  },
  {
    label: "初中及以下学历",
    value: "0",
  },
];

const schoolTypeList = [
  {
    label: "统招一本",
    value: "1",
  },
  {
    label: "211",
    value: "2",
  },
  {
    label: "985",
    value: "3",
  },
  {
    label: "二本",
    value: "4",
  },
  {
    label: "大专",
    value: "5",
  },
  {
    label: "职院",
    value: "6",
  },
  {
    label: "中专",
    value: "7",
  },
  {
    label: "高中",
    value: "8",
  },
  {
    label: "初中",
    value: "9",
  },
  {
    label: "小学",
    value: "10",
  },
];

// 婚姻状态
const maritalStatusList = [
  {
    value: 1,
    label: "未婚",
  },
  {
    value: 2,
    label: "已婚",
  },
  {
    value: 3,
    label: "离异",
  },
];

// 在职状态
const resumeStatusList = [
  {
    value: 3,
    label: "离职",
  },
  {
    value: 1,
    label: "在职-考虑机会",
  },
  {
    value: 2,
    label: "在职-月内到岗",
  },
];

export default {
  name: "EditResume",
  data() {
    return {
      url: url,
      educationList: mindEducationList,
      schoolTypeList: schoolTypeList,
      maritalStatusList: maritalStatusList,
      resumeStatusList: resumeStatusList,
      industryList: [],
      form: {
        baseInfo: {},
        workExperiences: [],
        projectExperience: [],
        educations: [],
      },
      showForm: {
        workExperiences: [],
        projectExperience: [],
        educations: [],
      },
      baseInfo: {
        avatar: default_avatar,
        resumeType: "1",
        resumeSource: 4,
        name: "",
        gender: "0",
        birthDate: "1998-01-01",
        maritalStatus: 1,
        nationality: "中国",
        phone: "",
        wechat: "",
        email: "",
        qq: "",
        employmentStatus: 3,
      },
      dynamicTags: [],
      inputVisible: false,
      inputValue: "",
    };
  },
  computed: {
    itemText() {
      return this.industryList.find(
        (e) => e.item.itemId == this.baseInfo.itemId
      ).item.itemName;
    },
  },
  watch: {
    baseInfo: {
      deep: true,
      handler: function (val) {
        localStorage.setItem("resumeBaseInfo", JSON.stringify(this.baseInfo));
      },
    },
    showForm: {
      deep: true,
      handler: function (val) {
        localStorage.setItem("resumeForm", JSON.stringify(this.showForm));
      },
    },
  },
  methods: {
    scrollTo(e) {
      // 页面往上滚动50px
      window.scrollBy({
        top: -100,
        left: 0,
        behavior: "smooth",
      });
    },
    getDateStr(date) {
      let day = new Date(date);
      return `${day.getFullYear()}年${day.getMonth() + 1}月${day.getDate()}日`;
    },
    // 时间格式化为 YYYY-MM-DD HH:mm:ss
    formatDate(e) {
      let date = new Date(e);

      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();

      return `${year}-${month}-${day} 00:00:00`;
    },
    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.dynamicTags.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
    getDateStr(e) {
      let date = new Date(e);
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();

      return `${year}-${month > 9 ? month : "0" + month}-${
        day > 9 ? day : "0" + day
      }`;
    },
    async getTalentDetail() {
      if (!this.$route.query.openid) return;
      const res = await this.httpRequest(
        `noAuth/queryTalentDetailByOpenid?openid=${this.$route.query.openid}`,
        {},
        "get"
      );
      if (res.code != 200) {
        this.$message.error(res.msg);
        return;
      }

      // 过滤掉没有数据的
      if (!res.data) return;

      this.baseInfo = res.data;
      this.baseInfo.birthDate = this.getDateStr(
        res.data.birthDate || "1998-01-01"
      );
      this.form.educations = res.data.educations || [];
      this.form.workExperiences = res.data.workExperiences || [];
      this.form.projectExperience = res.data.projectExperiences || [];

      this.dynamicTags = res.data.tags.split(",");
    },
    async getIndustryType() {
      const res = await this.httpRequest("noAuth/industryType", {}, "get");
      if (res.code != 200) {
        this.$message.error(res.msg);
        return;
      }
      this.industryList = res.data;
    },
    async uploadFile(e) {
      const formData = new FormData();
      formData.append("file", e.file);
      const res = await this.httpRequest(
        "oss/uploadFile",
        formData,
        "post",
        {}
      );
      if (res.code != 200) {
        this.$message.error(res.message);
        return;
      }
      this.baseInfo.avatar = res.data;
    },
    checkForm() {
      let verify = false;

      if (!this.form.baseInfo.nationality) {
        this.$message.error("请填写国籍");
        verify = true;
      }

      if (!this.form.baseInfo.resumeStatus && !verify) {
        this.$message.error("请选择在职状态");
        verify = true;
      }

      if (!this.form.baseInfo.name && !verify) {
        this.$message.error("请填写姓名");
        verify = true;
      }

      if (!this.form.baseInfo.gender && !verify) {
        this.$message.error("请选择性别");
        verify = true;
      }

      if (!this.form.baseInfo.birthDate && !verify) {
        this.$message.error("请选择出生日期");
        verify = true;
      }

      if (!this.form.baseInfo.firstEducation && !verify) {
        this.$message.error("请选择学历");
        verify = true;
      }

      if (!this.form.baseInfo.registeredResidence && !verify) {
        this.$message.error("请填写户口所在地");
        verify = true;
      }

      if (!this.form.baseInfo.address && !verify) {
        this.$message.error("请填写现居住地");
        verify = true;
      }

      if (!this.form.baseInfo.phone && !verify) {
        this.$message.error("请填写手机号");
        verify = true;
      } else if (
        !/^1[3456789]\d{9}$/.test(this.form.baseInfo.phone) &&
        !verify
      ) {
        this.$message.error("请填写正确的手机号");
        verify = true;
      }

      if (!this.form.baseInfo.email && !verify) {
        this.$message.error("请填写邮箱");
        verify = true;
      } else if (
        !/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(
          this.form.baseInfo.email
        ) &&
        !verify
      ) {
        this.$message.error("请填写正确的邮箱");
        verify = true;
      }

      if (!this.form.baseInfo.jobFunction && !verify) {
        this.$message.error("请填写意向职位");
        verify = true;
      }

      if (!this.form.baseInfo.expectedSalary && !verify) {
        this.$message.error("请填写期望年薪");
        verify = true;
      }

      if (!this.form.baseInfo.itemId && !verify) {
        this.$message.error("请选择行业");
        verify = true;
      }

      this.form.workExperiences.forEach((item) => {
        if (!item.companyName && !verify) {
          this.$message.error("请填写公司名称");
          verify = true;
        }

        if (!item.department && !verify) {
          this.$message.error("请填写部门名称");
          verify = true;
        }

        if (!item.position && !verify) {
          this.$message.error("请填写职位名称");
          verify = true;
        }

        if (!item.startDate && !item.endDate && !verify) {
          this.$message.error("请填写在职时间");
          verify = true;
        }

        if (!item.selfEvaluation && !verify) {
          this.$message.error("请填写工作内容");
          verify = true;
        }

        if (item.startDate && !verify)
          item.startDate = this.formatDate(item.startDate);
        if (item.endDate && !verify)
          item.endDate = this.formatDate(item.endDate);
      });

      this.form.projectExperience.forEach((item) => {
        if (!item.projectName && !verify) {
          this.$message.error("请填写项目名称");
          verify = true;
        }

        if (!item.projectPosition && !verify) {
          this.$message.error("请填写项目职位");
          verify = true;
        }

        if (!item.startDate && !item.endDate && !verify) {
          this.$message.error("请填写项目时间");
          verify = true;
        }

        if (!item.projectDescription && !verify) {
          this.$message.error("请填写项目介绍");
          verify = true;
        }

        if (item.startDate && !verify)
          item.startDate = this.formatDate(item.startDate);
        if (item.endDate && !verify)
          item.endDate = this.formatDate(item.endDate);
      });

      // 最少填写一条教育经历
      if (this.form.educations.length == 0 && !verify) {
        this.$message.error("请填写至少一条教育经历");
        verify = true;
      }

      this.form.educations.forEach((item) => {
        if (!item.schoolName && !verify) {
          this.$message.error("请填写学校名称");
          verify = true;
        }

        if (!item.major && !verify) {
          this.$message.error("请填写专业名称");
          verify = true;
        }

        if (!item.degree && !verify) {
          this.$message.error("请选择学历");
          verify = true;
        }

        if (!item.schoolType && !verify) {
          this.$message.error("请选择学校类型");
          verify = true;
        }

        if (!item.startDate && !item.endDate && !verify) {
          this.$message.error("请选择学历时间");
          verify = true;
        }

        if (!item.majorDescription && !verify) {
          this.$message.error("请填写专业描述");
          verify = true;
        }
        if (item.startDate && !verify)
          item.startDate = this.formatDate(item.startDate);
        if (item.endDate && !verify)
          item.endDate = this.formatDate(item.endDate);
      });

      return verify;
    },
    save() {
      this.form = JSON.parse(JSON.stringify(this.showForm));
      this.form.baseInfo = JSON.parse(JSON.stringify(this.baseInfo));
      if (this.form.baseInfo.birthDate)
        this.form.baseInfo.birthDate = this.formatDate(
          this.form.baseInfo.birthDate
        );

      const industry = this.industryList.find(
        (e) => e.item.itemId == this.form.baseInfo.itemId
      );
      this.form.baseInfo.itemName = industry ? industry.item.itemName : "";
      this.form.baseInfo.industryName = industry ? industry.typeName : "";
      this.form.baseInfo.industryId = industry ? industry.typeId : "";

      this.form.baseInfo.tags = this.dynamicTags.join(",");
      if (this.checkForm()) return;

      this.form.baseInfo.openid = this.$route.query.openid;
      this.form.baseInfo.unionid = this.$route.query.unionid;

      if (this.$route.query.isSubcode == "Y") {
        this.form.isSubcode = "Y";
        this.form.subUserId = this.$route.query.hrUserId;
      }

      this.httpRequest(
        `noAuth/addTalent?hrUserId=${this.$route.query.hrUserId}`,
        this.form,
        "post",
        {
          "Content-Type": "application/json",
        }
      ).then((res) => {
        if (res.code != 200) {
          this.$message.error("保存简历成功");
          localStorage.removeItem("resumeBaseInfo");
          localStorage.removeItem("resumeForm");
          return;
        }
        this.$message.success(res.message);

        // 返回上一页
        wx.miniProgram.navigateBack();
      });
    },
    httpRequest(path, params = {}, method = "post", header = {}) {
      return new Promise((resolve, reject) => {
        // 创建配置对象
        const config = {
          url: `${this.url}${path}`,
          method: method,
          headers: header,
          dataType: "json",
          success: (response) => resolve(response),
          error: (xhr, status, error) => reject(error),
        };

        // 如果是 JSON 请求，序列化数据并设置 processData
        if (header["Content-Type"] === "application/json") {
          config.data = JSON.stringify(params);
          config.processData = false; // 防止 jQuery 转换数据
          config.contentType = "application/json"; // 确保正确设置
        } else {
          config.contentType = false;
          config.processData = false;
          config.data = params;
        }
        $.ajax(config);
      });
    },
  },
  mounted() {
    this.getIndustryType();
    this.getTalentDetail();

    this.baseInfo = JSON.parse(localStorage.getItem("resumeBaseInfo")) || {
      name: "",
      birthDate: "",
      phone: "",
      email: "",
      address: "",
      avatar: "",
      itemId: "",
      jobFunction: "",
    };
    this.showForm = JSON.parse(localStorage.getItem("resumeForm")) || {
      baseInfo: {},
      workExperiences: [],
      projectExperience: [],
      educations: [],
    };
  },
};
</script>
<style scoped>
@import url(./index.css);
</style>



// WEBPACK FOOTER //
// src/pages/edit-resume/index.vue